// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Timeline Horizontal Container */
.timeline-horizontal {
  display: flex;
  gap: 20px;
  position: relative;
  padding: 20px 0;
  overflow-x: auto;
  overflow-y: visible;
}

/* Horizontal connecting line */
.connecting-line {
  position: absolute;
  top: 35px;
  left: 55px;
  right: 55px;
  height: 3px;
  background: #dee2e6;
  border-radius: 2px;
  z-index: 1;
  overflow: hidden;
}

.connecting-line-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(to right, #28a745 0%, #28a745 100%);
  transition: width 0.8s ease;
  box-shadow: 0 0 6px rgba(40, 167, 69, 0.4);
  animation: fillLine 1.2s ease-in-out forwards;
}

/* Green line fill animation on load */
@keyframes fillLine {
  from {
    width: 0;
  }
  to {
    width: var(--fill-width, 100%);
  }
}

/* Optional: rejected line color */
.connecting-line-fill.rejected {
  background: linear-gradient(to right, #dc3545 0%, #dc3545 100%);
  box-shadow: 0 0 6px rgba(220, 53, 69, 0.4);
}

/* Timeline Step */
.timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 280px;
  max-width: 280px;
  position: relative;
  z-index: 2;
  flex: 1 1;
}

/* Circle Wrapper */
.step-circle-wrapper {
  margin-bottom: 12px;
  flex-shrink: 0;
  height: 40px;
  width: 40px;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  background: #fff;
  position: relative;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.circle-fill {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  animation: fillUp 0.8s ease forwards;
  z-index: 1;
}

@keyframes fillUp {
  from {
    height: 0;
  }
  to {
    height: 100%;
  }
}

.circle-content {
  position: relative;
  z-index: 2;
  color: #6c757d;
  transition: color 0.3s ease 0.4s;
}

.step-circle.animate-fill .circle-content {
  color: #fff;
}

/* START Circle */
.start-circle {
  background: #28a745 !important;
  border: none !important;
}

.start-circle .circle-content {
  color: #fff !important;
}

/* END Circle */
.end-circle {
  background: #0d6efd !important;
  border: none !important;
  animation: pulse-blue 2s infinite;
}

.end-circle .circle-content {
  color: #fff !important;
}

/* Middle Circles */
.middle-circle {
  border: 3px solid #dee2e6 !important;
  background: #fff !important;
}

@keyframes pulse-blue {
  0%,
  100% {
    box-shadow: 0 3px 10px rgba(13, 110, 253, 0.4);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 3px 15px rgba(13, 110, 253, 0.7);
    transform: scale(1);
  }
}

.circle-text {
  font-size: 0.5rem;
  font-weight: 700;
  color: #fff !important;
}

.circle-icon-small {
  font-size: 1rem;
}

/* Card */
.step-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 14px;
  width: 100%;
  min-height: 240px;
  height: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transform: translateY(15px);
  box-sizing: border-box;
}

.card-fade-in {
  animation: fadeInUp 0.6s ease forwards 0.3s;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Avatar */
.step-avatar-wrapper {
  display: flex;
  justify-content: center;
}

.step-avatar-small {
  width: 44px;
  height: 44px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  border: 2px solid #dee2e6;
  background: #fff;
}

.avatar-fill-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  animation: fillUp 0.8s ease forwards 0.2s;
}

.avatar-icon-small {
  font-size: 1.15rem;
  position: relative;
  z-index: 2;
  transition: color 0.3s ease 0.6s;
}

.step-avatar-small.avatar-fill .avatar-icon-small {
  color: #fff;
}

/* User Info */
.step-info {
  text-align: center;
}

.step-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #212529;
  margin-bottom: 3px;
}

.step-id {
  color: #6c757d;
  font-weight: 500;
  font-size: 0.78rem;
  display: block;
}

.step-role {
  font-size: 0.73rem;
  color: #6c757d;
  margin: 0;
}

/* Status Badge */
.step-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 12px;
  border-radius: 14px;
  font-size: 0.78rem;
  font-weight: 600;
  border: 2px solid;
  text-align: center;
  align-self: center;
}

.pending-pulse {
  animation: pulsePending 2s infinite;
}

@keyframes pulsePending {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(220, 53, 69, 0);
  }
}

.completed-status {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
  color: #0d6efd !important;
  border-color: #0d6efd !important;
}

/* Time */
.step-time {
  display: flex;
  flex-direction: column;
  gap: 5px;
  text-align: center;
  padding: 10px;
  background: #fafafa;
  border-radius: 6px;
}

.time-ago {
  font-size: 0.73rem;
  color: #495057;
  font-weight: 500;
}

.time-stamp {
  font-size: 0.65rem;
  color: #6c757d;
}

/* Quote */
.step-quote {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #fafafa;
  border-radius: 6px;
}

.quote-icon-wrapper-small {
  width: 28px;
  height: 28px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  border: 2px solid #dee2e6;
  background: #fff;
}

.icon-fill-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0;
  animation: fillUp 0.8s ease forwards 0.4s;
}

.quote-icon-small {
  color: #6c757d;
  font-size: 0.85rem;
  position: relative;
  z-index: 2;
}

.quote-content {
  font-size: 0.78rem;
  color: #6c757d;
  font-style: italic;
  flex: 1 1;
}

.timeline-horizontal-compact {
  display: flex;
  gap: 180px;
  position: relative;
  padding: 0 0;
  overflow-x: auto;
  align-items: center;
  justify-content: center;
}

/* Connecting line for compact view */
.timeline-horizontal-compact .connecting-line {
  position: absolute;
  top: 20px;
  left: 60px;
  right: 60px;
  height: 3px;
  background: #dee2e6;
  border-radius: 2px;
  z-index: 1;
  overflow: hidden;
}

/* Green fill animation for compact view */
.timeline-horizontal-compact .connecting-line-fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: linear-gradient(to right, #28a745 0%, #28a745 100%);
  transition: width 0.8s ease;
  box-shadow: 0 0 6px rgba(40, 167, 69, 0.4);
  animation: fillLineCompact 1.2s ease-in-out forwards;
}

/* Compact view line fill animation */
@keyframes fillLineCompact {
  from {
    width: 0;
  }
  to {
    width: var(--fill-width, 100%);
  }
}

.timeline-step-compact {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  min-width: 120px;
  position: relative;
  z-index: 2;
}

.compact-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.compact-status-badge {
  padding: 5px 12px;
  border-radius: 14px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 2px solid;
  transition: all 0.3s ease;
}

.compact-status-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.pending-pulse-compact {
  animation: pulsePendingCompact 2s infinite;
}

@keyframes pulsePendingCompact {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
  }
}

.compact-name {
  font-size: 0.8rem;
  color: #495057;
  font-weight: 600;
  text-align: center;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.compact-time {
  font-size: 0.7rem;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 2px;
}

/* Responsive */
@media (max-width: 992px) {
  .timeline-horizontal {
    flex-direction: column;
    gap: 0;
    padding: 15px 0;
  }

  .connecting-line {
    top: 35px;
    left: 20px;
    right: auto;
    width: 3px;
    height: calc(100% - 70px);
  }

  .connecting-line-fill {
    width: 100% !important;
    height: 0 !important;
    animation: fillLineVertical 1.2s ease-in-out forwards !important;
  }

  @keyframes fillLineVertical {
    from {
      height: 0;
    }
    to {
      height: var(--fill-height, 100%);
    }
  }

  .timeline-step {
    flex-direction: row;
    min-width: 100%;
    max-width: 100%;
    margin-bottom: 15px;
  }

  .step-circle-wrapper {
    margin-right: 15px;
    margin-bottom: 0;
  }

  .step-card {
    flex: 1 1;
    min-height: auto;
  }

  .step-info {
    text-align: left;
  }

  /* Compact view responsive */
  .timeline-horizontal-compact {
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
  }

  .timeline-horizontal-compact .connecting-line {
    top: 20px;
    left: 20px;
    right: auto;
    width: 3px;
    height: calc(100% - 40px);
  }

  .timeline-horizontal-compact .connecting-line-fill {
    width: 100% !important;
    height: 0 !important;
    animation: fillLineVerticalCompact 1.2s ease-in-out forwards !important;
  }

  @keyframes fillLineVerticalCompact {
    from {
      height: 0;
    }
    to {
      height: var(--fill-height, 100%);
    }
  }

  .timeline-step-compact {
    flex-direction: row;
    min-width: 100%;
    gap: 15px;
  }

  .compact-label {
    align-items: flex-start;
    flex: 1 1;
  }

  .compact-name {
    text-align: left;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .timeline-horizontal-compact {
    gap: 15px;
  }

  .timeline-step-compact {
    min-width: 100px;
  }

  .compact-status-badge {
    font-size: 0.7rem;
    padding: 4px 10px;
  }

  .compact-name {
    font-size: 0.75rem;
  }

  .compact-time {
    font-size: 0.65rem;
  }
}

/* Remove overflow: hidden from both connecting-line rules */
.connecting-line {
  position: absolute;
  top: 35px;
  left: 55px;
  right: 55px;
  height: 3px;
  background: #dee2e6;
  border-radius: 2px;
  z-index: 1;
  overflow: visible; /* ← changed from hidden to visible */
}

.timeline-horizontal-compact .connecting-line {
  position: absolute;
  top: 20px;
  left: 60px;
  right: 60px;
  height: 3px;
  background: #dee2e6;
  border-radius: 2px;
  z-index: 1;
  overflow: visible; /* ← changed from hidden to visible */
}

/* Green dots at start and end */
.connecting-line::before,
.connecting-line::after {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #28a745;
  z-index: 3;
  box-shadow: 0 0 4px rgba(40, 167, 69, 0.5);
}

.connecting-line::before {
  left: -5px;
}

.connecting-line::after {
  right: -5px;
}

/* Scoped ONLY to this component — safe, won't affect other pages */
/* .workflow-status-wrapper {
  margin: 0;
  padding: 0;
} */

.workflow-status-wrapper {
  margin-bottom: 16px !important;
}

.workflow-status-row {
  margin: 0 !important;
}

.workflow-status-col {
  padding: 0 !important;
}

.workflow-status-card {
  margin: 0 !important;
}

/* .workflow-status-body {
  padding: 10px !important;
} */

.workflow-status-body {
  padding: 8px 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/Components/Modal/supplier_app/Workflow/ShowHorizontalStatus.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,+DAA+D;EAC/D,2BAA2B;EAC3B,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA,sCAAsC;AACtC;EACE;IACE,QAAQ;EACV;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA,kCAAkC;AAClC;EACE,+DAA+D;EAC/D,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,8CAA8C;IAC9C,mBAAmB;EACrB;EACA;IACE,8CAA8C;IAC9C,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;;IAEE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,wEAAwE;EACxE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,+DAA+D;EAC/D,2BAA2B;EAC3B,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA,qCAAqC;AACrC;EACE;IACE,QAAQ;EACV;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;;IAEE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,MAAM;IACN,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,gEAAgE;EAClE;;EAEA;IACE;MACE,SAAS;IACX;IACA;MACE,gCAAgC;IAClC;EACF;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,uEAAuE;EACzE;;EAEA;IACE;MACE,SAAS;IACX;IACA;MACE,gCAAgC;IAClC;EACF;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;;EAEA;IACE,uBAAuB;IACvB,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,4DAA4D;AAC5D;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA,gCAAgC;AAChC;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,mEAAmE;AACnE;;;GAGG;;AAEH;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;GAEG;;AAEH;EACE,4BAA4B;AAC9B","sourcesContent":["/* Timeline Horizontal Container */\n.timeline-horizontal {\n  display: flex;\n  gap: 20px;\n  position: relative;\n  padding: 20px 0;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n/* Horizontal connecting line */\n.connecting-line {\n  position: absolute;\n  top: 35px;\n  left: 55px;\n  right: 55px;\n  height: 3px;\n  background: #dee2e6;\n  border-radius: 2px;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.connecting-line-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: linear-gradient(to right, #28a745 0%, #28a745 100%);\n  transition: width 0.8s ease;\n  box-shadow: 0 0 6px rgba(40, 167, 69, 0.4);\n  animation: fillLine 1.2s ease-in-out forwards;\n}\n\n/* Green line fill animation on load */\n@keyframes fillLine {\n  from {\n    width: 0;\n  }\n  to {\n    width: var(--fill-width, 100%);\n  }\n}\n\n/* Optional: rejected line color */\n.connecting-line-fill.rejected {\n  background: linear-gradient(to right, #dc3545 0%, #dc3545 100%);\n  box-shadow: 0 0 6px rgba(220, 53, 69, 0.4);\n}\n\n/* Timeline Step */\n.timeline-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 280px;\n  max-width: 280px;\n  position: relative;\n  z-index: 2;\n  flex: 1;\n}\n\n/* Circle Wrapper */\n.step-circle-wrapper {\n  margin-bottom: 12px;\n  flex-shrink: 0;\n  height: 40px;\n  width: 40px;\n}\n\n.step-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  background: #fff;\n  position: relative;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n}\n\n.circle-fill {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 0;\n  animation: fillUp 0.8s ease forwards;\n  z-index: 1;\n}\n\n@keyframes fillUp {\n  from {\n    height: 0;\n  }\n  to {\n    height: 100%;\n  }\n}\n\n.circle-content {\n  position: relative;\n  z-index: 2;\n  color: #6c757d;\n  transition: color 0.3s ease 0.4s;\n}\n\n.step-circle.animate-fill .circle-content {\n  color: #fff;\n}\n\n/* START Circle */\n.start-circle {\n  background: #28a745 !important;\n  border: none !important;\n}\n\n.start-circle .circle-content {\n  color: #fff !important;\n}\n\n/* END Circle */\n.end-circle {\n  background: #0d6efd !important;\n  border: none !important;\n  animation: pulse-blue 2s infinite;\n}\n\n.end-circle .circle-content {\n  color: #fff !important;\n}\n\n/* Middle Circles */\n.middle-circle {\n  border: 3px solid #dee2e6 !important;\n  background: #fff !important;\n}\n\n@keyframes pulse-blue {\n  0%,\n  100% {\n    box-shadow: 0 3px 10px rgba(13, 110, 253, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    box-shadow: 0 3px 15px rgba(13, 110, 253, 0.7);\n    transform: scale(1);\n  }\n}\n\n.circle-text {\n  font-size: 0.5rem;\n  font-weight: 700;\n  color: #fff !important;\n}\n\n.circle-icon-small {\n  font-size: 1rem;\n}\n\n/* Card */\n.step-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 14px;\n  width: 100%;\n  min-height: 240px;\n  height: 100%;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  opacity: 0;\n  transform: translateY(15px);\n  box-sizing: border-box;\n}\n\n.card-fade-in {\n  animation: fadeInUp 0.6s ease forwards 0.3s;\n}\n\n@keyframes fadeInUp {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Avatar */\n.step-avatar-wrapper {\n  display: flex;\n  justify-content: center;\n}\n\n.step-avatar-small {\n  width: 44px;\n  height: 44px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6c757d;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n  position: relative;\n  overflow: hidden;\n  border: 2px solid #dee2e6;\n  background: #fff;\n}\n\n.avatar-fill-bg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 0;\n  animation: fillUp 0.8s ease forwards 0.2s;\n}\n\n.avatar-icon-small {\n  font-size: 1.15rem;\n  position: relative;\n  z-index: 2;\n  transition: color 0.3s ease 0.6s;\n}\n\n.step-avatar-small.avatar-fill .avatar-icon-small {\n  color: #fff;\n}\n\n/* User Info */\n.step-info {\n  text-align: center;\n}\n\n.step-name {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #212529;\n  margin-bottom: 3px;\n}\n\n.step-id {\n  color: #6c757d;\n  font-weight: 500;\n  font-size: 0.78rem;\n  display: block;\n}\n\n.step-role {\n  font-size: 0.73rem;\n  color: #6c757d;\n  margin: 0;\n}\n\n/* Status Badge */\n.step-status {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 6px 12px;\n  border-radius: 14px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  border: 2px solid;\n  text-align: center;\n  align-self: center;\n}\n\n.pending-pulse {\n  animation: pulsePending 2s infinite;\n}\n\n@keyframes pulsePending {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(220, 53, 69, 0);\n  }\n}\n\n.completed-status {\n  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;\n  color: #0d6efd !important;\n  border-color: #0d6efd !important;\n}\n\n/* Time */\n.step-time {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  text-align: center;\n  padding: 10px;\n  background: #fafafa;\n  border-radius: 6px;\n}\n\n.time-ago {\n  font-size: 0.73rem;\n  color: #495057;\n  font-weight: 500;\n}\n\n.time-stamp {\n  font-size: 0.65rem;\n  color: #6c757d;\n}\n\n/* Quote */\n.step-quote {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  background: #fafafa;\n  border-radius: 6px;\n}\n\n.quote-icon-wrapper-small {\n  width: 28px;\n  height: 28px;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  border: 2px solid #dee2e6;\n  background: #fff;\n}\n\n.icon-fill-bg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 0;\n  animation: fillUp 0.8s ease forwards 0.4s;\n}\n\n.quote-icon-small {\n  color: #6c757d;\n  font-size: 0.85rem;\n  position: relative;\n  z-index: 2;\n}\n\n.quote-content {\n  font-size: 0.78rem;\n  color: #6c757d;\n  font-style: italic;\n  flex: 1;\n}\n\n.timeline-horizontal-compact {\n  display: flex;\n  gap: 180px;\n  position: relative;\n  padding: 0 0;\n  overflow-x: auto;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Connecting line for compact view */\n.timeline-horizontal-compact .connecting-line {\n  position: absolute;\n  top: 20px;\n  left: 60px;\n  right: 60px;\n  height: 3px;\n  background: #dee2e6;\n  border-radius: 2px;\n  z-index: 1;\n  overflow: hidden;\n}\n\n/* Green fill animation for compact view */\n.timeline-horizontal-compact .connecting-line-fill {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  background: linear-gradient(to right, #28a745 0%, #28a745 100%);\n  transition: width 0.8s ease;\n  box-shadow: 0 0 6px rgba(40, 167, 69, 0.4);\n  animation: fillLineCompact 1.2s ease-in-out forwards;\n}\n\n/* Compact view line fill animation */\n@keyframes fillLineCompact {\n  from {\n    width: 0;\n  }\n  to {\n    width: var(--fill-width, 100%);\n  }\n}\n\n.timeline-step-compact {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  min-width: 120px;\n  position: relative;\n  z-index: 2;\n}\n\n.compact-label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.compact-status-badge {\n  padding: 5px 12px;\n  border-radius: 14px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border: 2px solid;\n  transition: all 0.3s ease;\n}\n\n.compact-status-badge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.pending-pulse-compact {\n  animation: pulsePendingCompact 2s infinite;\n}\n\n@keyframes pulsePendingCompact {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);\n  }\n}\n\n.compact-name {\n  font-size: 0.8rem;\n  color: #495057;\n  font-weight: 600;\n  text-align: center;\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.compact-time {\n  font-size: 0.7rem;\n  color: #6c757d;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .timeline-horizontal {\n    flex-direction: column;\n    gap: 0;\n    padding: 15px 0;\n  }\n\n  .connecting-line {\n    top: 35px;\n    left: 20px;\n    right: auto;\n    width: 3px;\n    height: calc(100% - 70px);\n  }\n\n  .connecting-line-fill {\n    width: 100% !important;\n    height: 0 !important;\n    animation: fillLineVertical 1.2s ease-in-out forwards !important;\n  }\n\n  @keyframes fillLineVertical {\n    from {\n      height: 0;\n    }\n    to {\n      height: var(--fill-height, 100%);\n    }\n  }\n\n  .timeline-step {\n    flex-direction: row;\n    min-width: 100%;\n    max-width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .step-circle-wrapper {\n    margin-right: 15px;\n    margin-bottom: 0;\n  }\n\n  .step-card {\n    flex: 1;\n    min-height: auto;\n  }\n\n  .step-info {\n    text-align: left;\n  }\n\n  /* Compact view responsive */\n  .timeline-horizontal-compact {\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-start;\n  }\n\n  .timeline-horizontal-compact .connecting-line {\n    top: 20px;\n    left: 20px;\n    right: auto;\n    width: 3px;\n    height: calc(100% - 40px);\n  }\n\n  .timeline-horizontal-compact .connecting-line-fill {\n    width: 100% !important;\n    height: 0 !important;\n    animation: fillLineVerticalCompact 1.2s ease-in-out forwards !important;\n  }\n\n  @keyframes fillLineVerticalCompact {\n    from {\n      height: 0;\n    }\n    to {\n      height: var(--fill-height, 100%);\n    }\n  }\n\n  .timeline-step-compact {\n    flex-direction: row;\n    min-width: 100%;\n    gap: 15px;\n  }\n\n  .compact-label {\n    align-items: flex-start;\n    flex: 1;\n  }\n\n  .compact-name {\n    text-align: left;\n    max-width: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .timeline-horizontal-compact {\n    gap: 15px;\n  }\n\n  .timeline-step-compact {\n    min-width: 100px;\n  }\n\n  .compact-status-badge {\n    font-size: 0.7rem;\n    padding: 4px 10px;\n  }\n\n  .compact-name {\n    font-size: 0.75rem;\n  }\n\n  .compact-time {\n    font-size: 0.65rem;\n  }\n}\n\n/* Remove overflow: hidden from both connecting-line rules */\n.connecting-line {\n  position: absolute;\n  top: 35px;\n  left: 55px;\n  right: 55px;\n  height: 3px;\n  background: #dee2e6;\n  border-radius: 2px;\n  z-index: 1;\n  overflow: visible; /* ← changed from hidden to visible */\n}\n\n.timeline-horizontal-compact .connecting-line {\n  position: absolute;\n  top: 20px;\n  left: 60px;\n  right: 60px;\n  height: 3px;\n  background: #dee2e6;\n  border-radius: 2px;\n  z-index: 1;\n  overflow: visible; /* ← changed from hidden to visible */\n}\n\n/* Green dots at start and end */\n.connecting-line::before,\n.connecting-line::after {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #28a745;\n  z-index: 3;\n  box-shadow: 0 0 4px rgba(40, 167, 69, 0.5);\n}\n\n.connecting-line::before {\n  left: -5px;\n}\n\n.connecting-line::after {\n  right: -5px;\n}\n\n/* Scoped ONLY to this component — safe, won't affect other pages */\n/* .workflow-status-wrapper {\n  margin: 0;\n  padding: 0;\n} */\n\n.workflow-status-wrapper {\n  margin-bottom: 16px !important;\n}\n\n.workflow-status-row {\n  margin: 0 !important;\n}\n\n.workflow-status-col {\n  padding: 0 !important;\n}\n\n.workflow-status-card {\n  margin: 0 !important;\n}\n\n/* .workflow-status-body {\n  padding: 10px !important;\n} */\n\n.workflow-status-body {\n  padding: 8px 10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
